import React, { ComponentType } from 'react';
import { InputProps, components } from 'react-select';
import { DestinationOption } from '@lt/api/dist/methods/references/types';

export const Input: ComponentType<InputProps<DestinationOption, false>> = (props) => (
  <components.Input data-lpignore="true" {...props} isHidden={false} />
);
